<template>

  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" :disabled="showBigButtons" @click="cancel()">{{ (showBigButtons) ? "" : t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ props.title }}</ion-title>
      <ion-buttons slot="end">
        <ion-button :disabled="showBigButtons" @click="confirm()" :strong="true">{{ (showBigButtons) ? "" : t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>

     <div v-show="showBigButtons" id="header">
      <ion-grid>
        <div v-show="showScrollButtons">
          <ion-row >
            <ion-col size="4">
              <ion-button  class="general-big-button cancel-button-color done-button-width" @click="cancel()">{{ t("Cancel") }}</ion-button>      
            </ion-col>
            <ion-col size="4">
              <ion-button class="general-big-button done-button-color done-button-width" @click="confirm()" :strong="true">{{ t("Done") }}</ion-button>
            </ion-col>
            <ion-col size="2">
              <ion-button  class="general-big-button scroll-button-color scroll-button-width" @click="scrollPage('up')">{{ t("Scroll Up") }}</ion-button>
            </ion-col>
            <ion-col size="2">
              <ion-button  class="general-big-button scroll-button-color scroll-button-width" @click="scrollPage('down')">{{ t("Scroll Down") }}</ion-button>
            </ion-col>
          </ion-row>
        </div>
        <div v-show="!showScrollButtons">
          <ion-row >
            <ion-col size="6">
              <ion-button  class="general-big-button cancel-button-color done-button-width" @click="cancel()">{{ t("Cancel") }}</ion-button>      
            </ion-col>
            <ion-col size="6">
              <ion-button class="general-big-button done-button-color done-button-width" @click="confirm()" :strong="true">{{ t("Done") }}</ion-button>
            </ion-col>
  
          </ion-row>
        </div>
      </ion-grid>
    </div>  

  </ion-header>

  <ion-content class="ion-padding">
    <div id="page">

      <!-- if custom name not null then show it and a text block for the selected categories -->
      <!-- also use ion-checkbox instead of ion-radio to allow mulitple selection -->
      <div v-if="props.customName != null" >
        <ion-accordion-group :value="accordionsToOpen" :multiple="true">
          <div v-for="group in accordionLabels"  v-bind:key="group.index" >
            <div v-if="group.index >= 0">
              <ion-accordion :value="group.value">
                <ion-item slot="header" class="no-border">
                  <ion-label>
                    {{ group.label }}
                  </ion-label>
                </ion-item>

                <ion-list slot="content">
                  <div v-for="(item,i) in group.entries" v-bind:key="item.index">
                    <ion-item >
                      <ion-checkbox class="radio-entry"
                                    :value="item.radio" :aria-label="item" label-placement="end" justify="start"
                                    @ionChange="boxChecked($event,item)">
                        <span class="ion-text-wrap">{{ item.name }}
                        </span>
                      </ion-checkbox>
                    </ion-item>
                  </div>
                </ion-list>
              </ion-accordion>
            </div>
          </div>
        </ion-accordion-group>
      </div>

      <!-- This is for single selection accordion -->

      <div v-if="props.customName == null">
        <ion-radio-group :value="props.initialValue" @ionChange="selectionChange($event)">
          <ion-accordion-group :value="accordionsToOpen" :multiple="true">
            <div v-for="group in accordionLabels"  v-bind:key="group.index" >
              <div v-if="group.index >= 0">
                <ion-accordion :value="group.value" :id="group.value">
                  <ion-item slot="header">
                    <ion-label>
                      {{ group.label }}
                    </ion-label>
                    <ion-icon v-show="isSubscriber != '1' && group.mustBeSubscriber == true" :icon="lockClosedOutline" slot="start"></ion-icon>
                  </ion-item>

                  <ion-list slot="content">
                    <div v-for="(item,i) in group.entries" v-bind:key="item.index">
                      <div :id="group.value + item.id">
                      <ion-item>
                        <ion-radio class="radio-entry" 
                                      :value="item.radio" :aria-label="item" label-placement="end" justify="start"
                                      >
                          <span class="ion-text-wrap">{{ item.name }}
                          </span>
                        </ion-radio>
                        <div v-show="isSubscriber == '1' && item.favorite == true"><ion-icon size="medium" slot="end" :icon="heartFullIcon" @click="heartClick(item)"></ion-icon></div>
                        <div v-show="isSubscriber == '1' && item.favorite == false"><ion-icon size="medium" :icon="heartOutline" @click="heartClick(item)"></ion-icon></div>
                      </ion-item>
                    </div>
                    </div>
                  </ion-list>
                </ion-accordion>
              </div>
            </div>
          </ion-accordion-group>
        </ion-radio-group>
      </div>
    </div>
  </ion-content>
</template>
  
  <script  setup>

    // accordion customizing https://www.youtube.com/watch?v=41fe14lhfBs

    import {
      IonGrid,IonRow,IonCol,
      IonCheckbox,
      IonIcon,
      IonAccordion,
      IonAccordionGroup,
      IonLabel,
      IonList,
      IonRadio,
      IonRadioGroup,
      IonContent,
      IonHeader,
      IonTitle,
      IonToolbar,
      IonButtons,
      IonButton,
      IonItem,
      modalController,
    } from '@ionic/vue';
           
    import {  heartOutline, heartSharp,lockClosedOutline } from 'ionicons/icons';

    import { defineComponent, ref } from 'vue';
    import { onMounted } from 'vue'
    import { t } from '@/composables/translateText.js'
    import { useConnectionStore } from '@/stores/connectionStore';

    const props = defineProps({
      
      accordionsToOpen : {
        type : Array,
        default : ["all"]
      },
      accordionLabels : {
        type : Array,
        default : []
      },
      title : {
        type : String,
        default : "TITLE"
      },
      displayArray : {
        type : Array,
        default : []
      },
      initialValue : {
        type :String,
        default : "1"
      },
      customName : {
        type : String,
        default : null
      }
      })
  
    //console.log("PROPS IN ACCORDION",props)

    const selectedValue = ref(props.initialValue)
    const accordionsToOpen = ref(props.accordionsToOpen)
    const accordionLabels = ref(props.accordionLabels)
    const heartOutlineIcon = ref(heartOutline)
    const heartFullIcon = ref(heartSharp)

    const connectionStore = useConnectionStore()
    const isSubscriber = connectionStore.getIsSubscriber

    const whichMenu = localStorage.getItem("whichMenu")
    const showBigButtons = ref(props.forceBigButtons || whichMenu == "buttons" || connectionStore.getShowBigButtons)
    const scalePercentage = connectionStore.getToolbarScalePercentage

    const radioButtonHeight = 30
    const useRadioButtonHeight = (showBigButtons.value) ? Math.floor( radioButtonHeight * scalePercentage / 100.0) :
                  radioButtonHeight
    const doneButtonHeight = 50
    const useDoneButtonHeight = (showBigButtons.value) ? Math.floor( doneButtonHeight * scalePercentage / 100.0) :
                  doneButtonHeight
    const showScrollButtons = ref(true)

    var favoriteChanged = false
    var groupsOpen = props.accordionsToOpen
    var scrollIncrement = 0
    var currentScrollIndex = 0
    var scrollableCategoryArray = []

    // load the initial values
    buildScrollableCategoryArray()

    onMounted(() => {
      var element = document.getElementById("page")
      if (element != null) {
        const groupHeadingSize = (useRadioButtonHeight > 50) ? useRadioButtonHeight : 50
        const heartButtonHeight = Math.floor(useRadioButtonHeight * 0.67)
        element.style.setProperty("--group_heading_size", groupHeadingSize + "px");
        element.style.setProperty("--radio_button_size", useRadioButtonHeight + "px");
        element.style.setProperty("--heart_button_size", heartButtonHeight + "px");
      }
      element = document.getElementById("header")
      if (element != null)
        element.style.setProperty("--done_button_size", useDoneButtonHeight + "px");
      buildStyles()
    })

     function buildStyles() {

      const modalHeight = (window.innerHeight || document.documentElement.clientHeight)
      const headingHeight = (showBigButtons.value) ? (useDoneButtonHeight + 50) : 0
      const spaceForButtons = modalHeight - headingHeight
      //console.log("spaceforbuttons",spaceForButtons)

      scrollIncrement = Math.floor(spaceForButtons / (useRadioButtonHeight + 8) )
      if (scrollIncrement == 0)
        scrollIncrement = 1
      //console.log("Scroll Increment",scrollIncrement)
    }

    function scrollPage(direction) {
      if (direction == "up") {
        if (currentScrollIndex > 0)
          currentScrollIndex -= scrollIncrement;
        if (currentScrollIndex < 0)
          currentScrollIndex = 0
      }
      else {
        if (currentScrollIndex < scrollableCategoryArray.length -1)
          currentScrollIndex += scrollIncrement
        if (currentScrollIndex > scrollableCategoryArray.length -1)
          currentScrollIndex = scrollableCategoryArray.length -1
      }
      const id = scrollableCategoryArray[currentScrollIndex]
      const element = document.getElementById(id)
      //console.log("Scroll to Element",element)
      if (element != null)
        element.scrollIntoView({ behavior: "smooth" })
      //scrollElement("page",direction)
    }

    // build array of groups and categories that are open so they can be scrolled based on # visible at a time
    function buildScrollableCategoryArray() {
      // build map of open group names for easy access
      const groupsOpenMap = new Map()
      for (var i = 0; i < groupsOpen.length; i++)
        groupsOpenMap.set(groupsOpen[i],"a")
      scrollableCategoryArray = []
      for (var group=0; group < props.accordionLabels.length; group++) {
        scrollableCategoryArray.push(props.accordionLabels[group].value)

        // if group is open, add the categories to the scrollable list
        if (groupsOpenMap.has(props.accordionLabels[group].value)) {
          for (var item = 0; item < props.accordionLabels[group].entries.length; item++) {
            scrollableCategoryArray.push(props.accordionLabels[group].value +
                        props.accordionLabels[group].entries[item].id)
          }
        }
      }
      //console.log("*** SCROLLABLE ARRAY",scrollableCategoryArray)

      // did the array get shortened to the extent that the current index is past the end of the array?
      if (currentScrollIndex >= scrollableCategoryArray.length)
        currentScrollIndex = scrollableCategoryArray.length - 1
    }

    function heartClick(item) {
      //console.log("HEART CLICK",item)
      item.favorite = !item.favorite
      favoriteChanged = true
    }
  
    function cancel() {
      modalController.dismiss(null, 'cancel');
    }
  
    function confirm() {

      // if favorite changed, build string of favorite ids and send back as string
      // skip the favorites group since they're all duplicates
      var favorites = []
      //console.log("in confirm",accordionLabels.value)
      for (var group = 1; group < accordionLabels.value.length; group++)
        for (var item = 0; item < accordionLabels.value[group].entries.length; item++)
          if (accordionLabels.value[group].entries[item].favorite)
            favorites.push(accordionLabels.value[group].entries[item].id)
      const favoritesString = favorites.join(",")
      //console.log("FavoritesString",favoritesString)

      var result = { 
            selected : selectedValue.value,
            favoritesChanged : favoriteChanged,
            favoritesString : favoritesString
          }
  
      //console.log("CONFIRM",result)
      modalController.dismiss(result, 'confirm');
    }
  
    function selectionChange(ev) {
      //console.log("selection Change",ev.detail)

      // clicks on group heading supply array of groups currently open
      if (ev.detail.event == undefined) {
        //console.log("Heading click open groups are:",ev.detail.value)
        groupsOpen = ev.detail.value
        buildScrollableCategoryArray()
        return
      }
      //console.log("selection Change",ev.detail)
      //console.log('Current value:', JSON.stringify(ev.detail.value));
      selectedValue.value = ev.detail.value

      // TESTING SCROLL
      const element = document.getElementById("phases10")
      //console.log("Scroll to Element",element)
      if (element != null)
        element.scrollIntoView({ behavior: "smooth" })
    }

    function boxChecked(ev,item) {
      //console.log("box checked",ev.detail,item)
    }
  
  </script>
  
  <style scoped>
  

  #page {
    --radio_button_size : 30px;
    --group_heading_size : 50px;
    --heart_button_size : 20px;
  }

  ion-radio::part(container) {
    width: var(--radio_button_size);
    height: var(--radio_button_size);

    border-radius: 8px;
    border: 2px solid #ddd;
  }

  .radio-entry {
    border-bottom : 5px;
    border-color : yellow;
    margin-top : 5px;
  }

  
    ion-radio::part(mark) {
      background: none;
      transition: none;
      transform: none;
      border-radius: 0;
    }
  
    ion-radio.radio-checked::part(container) {
      background: #6815ec;
      border-color: transparent;
    }
  
    ion-radio.radio-checked::part(mark) {
      width: 6px;
      height: 10px;
  
      border-width: 0px 2px 2px 0px;
      border-style: solid;
      border-color: #fff;
  
      transform: rotate(45deg);
    }

    /* from modal generic single list */

    #header {
      --done_button_size : 50px;
    }

    .title_text {
      background-color: #0d6efd;
      text-align: center;
      font-size: 24px;
    }

    .done-button-width {
      width : 100%;
    }
    .scroll-button-width {
      width : 100%;
    }

    .accordion_group {
      background-color: red;
    }

       /* Style the header item */
     /* ion-item[slot="header"] button .item-inner {
      border: 5px solid red;
      background-color: teal;
    }  */

    ion-accordion ion-item[slot="header"] {
      height : var(--group_heading_size);
      border-width : 0px;
    }

    .no-border {
      border : none;
    }

    ion-accordion.accordion-expanded ion-item[slot="header"] {
      background-color: #09024C;
      border : none;
    }

     ion-accordion.accordion-collapsed ion-item[slot="header"] {
      background-color: #558AF7;

    }

    ion-icon {
      font-size: var(--heart_button_size);
    }
  </style>
  